(() => {
  if (window.__smInlinePoc) return;
  window.__smInlinePoc = true;

  const scriptConfig = document.currentScript?.dataset || {};

  window.ShopCart = {
    count: Number(scriptConfig.cartCount || 0),
  };

  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const toBoolean = (value) => value === true || value === 'true';

  const parseJson = (value, fallback = {}) => {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (_error) {
      return fallback;
    }
  };

  const toLowerCaseKeys = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return value;

    return Object.keys(value).reduce((accumulator, key) => {
      const child = value[key];
      accumulator[key.toLowerCase()] = child && typeof child === 'object'
        ? toLowerCaseKeys(child)
        : child;
      return accumulator;
    }, {});
  };

  const setImportantColor = (element, value) => {
    if (element && value) element.style.setProperty('color', value, 'important');
  };

  const applyNestedMenuColors = ({ root, colors, namespace, level1Selector, level2Selector, level3Selector }) => {
    const colorRoot = colors?.[namespace];
    if (!root || !colorRoot) return;

    const level1Links = root.querySelectorAll(level1Selector);
    const level2Links = root.querySelectorAll(level2Selector);
    const level3Links = root.querySelectorAll(level3Selector);

    level1Links.forEach((link) => {
      const linkTitle = link.textContent.trim().toLowerCase();
      const colorOrObject = colorRoot[linkTitle];
      if (!colorOrObject) return;

      if (typeof colorOrObject === 'string') {
        setImportantColor(link, colorOrObject);
      } else if (colorOrObject._self) {
        setImportantColor(link, colorOrObject._self);
      }

      level2Links.forEach((link2) => {
        const parentItem = link2.closest('[data-nav-level="1"]');
        if (!parentItem || !parentItem.contains(link)) return;

        const linkTitle2 = link2.textContent.trim().toLowerCase();
        const colorOrObject2 = colorRoot[linkTitle]?.[linkTitle2];
        if (!colorOrObject2) return;

        if (typeof colorOrObject2 === 'string') {
          setImportantColor(link2, colorOrObject2);
        } else if (colorOrObject2._self) {
          setImportantColor(link2, colorOrObject2._self);
        }
        link2.style.borderBottom = '1px solid #000';

        level3Links.forEach((link3) => {
          const parentLevel2 = link3.closest('[data-nav-level="2"]');
          if (!parentLevel2 || !parentLevel2.contains(link2)) return;

          const linkTitle3 = link3.textContent.trim().toLowerCase();
          setImportantColor(link3, colorRoot[linkTitle]?.[linkTitle2]?.[linkTitle3]);
        });
      });
    });
  };

  const initMegaMenus = () => {
    document.querySelectorAll('[data-sm-mega-menu]').forEach((nav) => {
      if (nav.dataset.smMegaBound !== 'true') {
        nav.dataset.smMegaBound = 'true';

        const elementClass = Array.from(nav.classList).find(
          (className) => className === 'men-menu' || className.startsWith('normal-menu-a')
        );

        if (elementClass) {
          nav.querySelectorAll('.mega-menu').forEach((item) => {
            item.addEventListener('mouseover', () => {
              item.open();
              const submenu = item.querySelector('ul');
              if (submenu && submenu.dataset.smMouseleaveBound !== 'true') {
                submenu.dataset.smMouseleaveBound = 'true';
                submenu.addEventListener('mouseleave', () => item.close());
              }
            });

            item.addEventListener('mouseleave', () => item.close());
          });
        }
      }

      const colors = toLowerCaseKeys(parseJson(nav.dataset.categoryColors));
      if (toBoolean(nav.dataset.categoryColorsWomen) && nav.classList.contains('normal-menu-a')) {
        applyNestedMenuColors({
          root: nav,
          colors,
          namespace: 'women',
          level1Selector: '.mega-menu__link--level-1',
          level2Selector: '.mega-menu__link--level-2',
          level3Selector: '[data-nav-level="3"] .mega-menu__link',
        });
      }

      if (toBoolean(nav.dataset.categoryColorsMen) && nav.classList.contains('men-menu')) {
        applyNestedMenuColors({
          root: nav,
          colors,
          namespace: 'men',
          level1Selector: '.mega-menu__link--level-1',
          level2Selector: '.mega-menu__link--level-2',
          level3Selector: '[data-nav-level="3"] .mega-menu__link',
        });
      }
    });

    document.querySelectorAll('.toggle-button').forEach((button) => {
      if (button.dataset.smToggleBound === 'true') return;
      button.dataset.smToggleBound = 'true';
      button.addEventListener('click', () => {
        const nearestDetails = button.closest('details');
        if (!nearestDetails) return;
        if (nearestDetails.hasAttribute('open')) nearestDetails.removeAttribute('open');
        else nearestDetails.setAttribute('open', 'value');
      });
    });
  };

  const initMobileHeaderDrawer = () => {
    const drawer = document.querySelector('[data-sm-header-drawer]');
    if (!drawer) return;

    const colors = toLowerCaseKeys(parseJson(drawer.dataset.categoryColorsMobile));
    if (Object.keys(colors).length) {
      const level1Links = drawer.querySelectorAll('.menu-drawer__navigation [data-nav-level="1"] .menu-drawer__menu-item');
      const level2Links = drawer.querySelectorAll('.menu-drawer__navigation [data-nav-level="2"] .menu-drawer__menu-item');
      const level3Links = drawer.querySelectorAll('.menu-drawer__navigation [data-nav-level="3"] .menu-drawer__menu-item');

      level1Links.forEach((link) => {
        const linkTitle = link.textContent.trim().toLowerCase();
        const colorOrObject = colors[linkTitle];
        if (!colorOrObject) return;

        if (typeof colorOrObject === 'string') setImportantColor(link, colorOrObject);
        else if (colorOrObject._self) setImportantColor(link, colorOrObject._self);

        level2Links.forEach((link2) => {
          const parentItem = link2.closest('[data-nav-level="1"]');
          if (!parentItem || !parentItem.contains(link)) return;

          const linkTitle2 = link2.textContent.trim().toLowerCase();
          const colorOrObject2 = colors[linkTitle]?.[linkTitle2];
          if (!colorOrObject2) return;

          if (typeof colorOrObject2 === 'string') setImportantColor(link2, colorOrObject2);
          else if (colorOrObject2._self) setImportantColor(link2, colorOrObject2._self);

          level3Links.forEach((link3) => {
            const parentLevel2 = link3.closest('[data-nav-level="2"]');
            if (!parentLevel2 || !parentLevel2.contains(link2)) return;
            const linkTitle3 = link3.textContent.trim().toLowerCase();
            setImportantColor(link3, colors[linkTitle]?.[linkTitle2]?.[linkTitle3]);
          });
        });
      });
    }

    if (!toBoolean(drawer.dataset.featureMobileMenNavigation)) return;

    drawer.querySelectorAll('.menu-drawer__wm-links--link').forEach((link) => {
      if (link.dataset.smMobileMenuBound === 'true') return;
      link.dataset.smMobileMenuBound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const selectedMenu = this.getAttribute('data-menu');
        const targetHref = this.getAttribute('href');
        document.querySelectorAll('.mob_nav_item').forEach((item) => { item.style.display = 'none'; });
        document.querySelectorAll(`.mob_${selectedMenu}_nav`).forEach((item) => { item.style.display = 'block'; });
        localStorage.setItem('selected-menu', selectedMenu);
        window.location.href = targetHref;
      });
    });

    const selectedMenu = localStorage.getItem('selected-menu') || 'women';
    document.querySelectorAll('.mob_nav_item').forEach((item) => { item.style.display = 'none'; });
    document.querySelectorAll(`.mob_${selectedMenu}_nav`).forEach((item) => { item.style.display = 'block'; });

    const logoLink = document.querySelector('a.header__heading-link[href="/"]');
    if (logoLink && logoLink.dataset.smMobileLogoBound !== 'true') {
      logoLink.dataset.smMobileLogoBound = 'true';
      logoLink.addEventListener('click', () => {
        document.querySelectorAll('.mob_men_nav').forEach((item) => { item.style.display = 'none'; });
        document.querySelectorAll('.mob_women_nav').forEach((item) => { item.style.display = 'block'; });
        localStorage.setItem('selected-menu', 'women');
      });
    }
  };

  const initHeaderNavigation = () => {
    const wrapper = document.querySelector('[data-sm-header-navigation]');
    if (!wrapper) return;

    const menMenuLink = document.querySelector('a.men_menu_below');
    if (menMenuLink && menMenuLink.dataset.smMenMenuBound !== 'true') {
      menMenuLink.dataset.smMenMenuBound = 'true';
      menMenuLink.addEventListener('click', (event) => {
        event.preventDefault();
        localStorage.setItem('men-menu', 'Yes');
        window.location.href = menMenuLink.getAttribute('href');
      });
    }

    if (wrapper.dataset.brand === 'steve_madden' && toBoolean(wrapper.dataset.featureWomenMenSection)) {
      const womenMenuLink = document.querySelector('a.women_menu_below');
      if (womenMenuLink && womenMenuLink.dataset.smWomenMenuBound !== 'true') {
        womenMenuLink.dataset.smWomenMenuBound = 'true';
        womenMenuLink.addEventListener('click', (event) => {
          event.preventDefault();
          localStorage.removeItem('men-menu');
          window.location.href = womenMenuLink.getAttribute('href');
        });
      }

      const logoLink = document.querySelector('a.header__heading-link');
      if (logoLink && logoLink.dataset.smHeaderLogoBound !== 'true') {
        logoLink.dataset.smHeaderLogoBound = 'true';
        logoLink.addEventListener('click', (event) => {
          localStorage.removeItem('men-menu');
          if (wrapper.dataset.region !== 'en_150') {
            event.preventDefault();
            const pathname = window.location.pathname.toLowerCase();
            window.location.href = window.location.origin + (pathname.indexOf('/fr') === 0 ? '/fr' : '/');
          }
        });
      }
    }

    const menMenuActive = localStorage.getItem('men-menu') === 'Yes';
    const menMenu = document.querySelector('[data-main-menu].men-menu');
    const normalMenu = document.querySelector('[data-main-menu].normal-menu-a');
    if (!menMenu || !normalMenu) return;

    if (menMenuActive && (window.location.href.indexOf('collection') > -1 || window.location.href.indexOf('/pages/mens') > -1)) {
      menMenu.style.display = 'block';
      normalMenu.style.display = 'none';
    } else {
      menMenu.style.display = 'none';
      normalMenu.style.display = 'block';
    }
  };

  const hideDigitalGiftCardDetails = () => {
    document.querySelectorAll('.cart-item__details').forEach((cartItem) => {
      const anchor = cartItem.querySelector('.cart-item__name');
      if (anchor && anchor.textContent.trim() === 'DIGITAL GIFT CARD') {
        const productOptionDetails = cartItem.querySelector('.product_option_details');
        if (productOptionDetails) productOptionDetails.style.display = 'none';
      }
    });
  };

  const initPreventClicks = () => {
    const selectors = [
      '.rebooted_grid .rebooted_grid_link',
      '.rebooted_grid .img_wrpr img',
      '.rebootedcnt_wrpr p',
      '.rebootedcnt_wrpr span',
    ];

    const hasMatchingElements = selectors.some((selector) => document.querySelector(selector));
    if (!hasMatchingElements) return;

    document.addEventListener('click', (event) => {
      if (event.target.matches(selectors.join(','))) event.preventDefault();
    }, { passive: false });
  };

  const isInternetExplorer = () => {
    const ua = window.navigator.userAgent;
    return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
  };

  const initIECartSubmitFallback = () => {
    if (!isInternetExplorer()) return;
    const cart = document.querySelector('#cart');
    const checkout = document.querySelector('#checkout');
    if (!cart || !checkout || cart.dataset.smIeSubmitFallback === 'true') return;

    cart.dataset.smIeSubmitFallback = 'true';
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    cart.appendChild(cartSubmitInput);
    checkout.addEventListener('click', () => cart.submit());
  };

  const initFeaturedProductIEFallback = () => {
    const configs = document.querySelectorAll('[data-sm-featured-product-ie]');
    if (!configs.length) return;

    if (!isInternetExplorer()) return;

    configs.forEach((config) => {
      const hiddenInput = document.querySelector(config.dataset.hiddenInputSelector);
      const variantPicker = document.querySelector(config.dataset.variantPickerSelector);
      const noscriptWrapper = document.querySelector(config.dataset.noscriptWrapperSelector);
      if (!hiddenInput || !variantPicker || !noscriptWrapper) return;

      const noScriptInputWrapper = document.createElement('div');
      noScriptInputWrapper.innerHTML = noscriptWrapper.textContent;
      variantPicker.outerHTML = noScriptInputWrapper.outerHTML;

      const variants = document.querySelector(config.dataset.variantsSelector);
      if (variants) {
        variants.addEventListener('change', (event) => {
          hiddenInput.value = event.currentTarget.value;
        });
      }
    });
  };

  const initFooterBehavior = () => {
    const footer = document.querySelector('[data-sm-footer]');
    if (!footer) return;

    if (window.innerWidth < 767) {
      const accordions = document.getElementsByClassName('accordion-footer');
      Array.from(accordions).forEach((accordion, index) => {
        if (accordion.dataset.smFooterAccordionBound !== 'true') {
          accordion.dataset.smFooterAccordionBound = 'true';
          accordion.addEventListener('click', function () {
            this.classList.toggle('active');
            const panel = this.nextElementSibling;
            if (!panel) return;
            panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
          });
        }

        if (toBoolean(footer.dataset.openLastAccordion) && index === accordions.length - 1) {
          const panel = accordion.nextElementSibling;
          if (panel) panel.style.display = 'block';
          accordion.classList.remove('accordion-footer');
        }
      });
    }

    if (window.jQuery) {
      window.jQuery('#ContactFooter').off('submit.smInlinePoc').on('submit.smInlinePoc', function (event) {
        event.preventDefault();
        const email = window.jQuery(this).find('input[name="contact[email]"]').val();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'submit_form',
          form_id: 'ContactFooter',
          email,
          _clear: true,
        });
      });
    }
  };

  const initAlgoliaHooks = () => {
    document.addEventListener('algolia.hooks.initialize', () => {
      if (!window.algoliaShopify?.hooks) return;
      window.algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', (options) => {
        options.container = document.getElementById('autocomplete');
        return options;
      });
    });
  };

  window.pushMainBannerToDataLayer = async (url, element) => {
    const getCreativeName = (data = {}) => data.promotionCreative_name || data.promotionCreative || data.promotionCreativeName || data.creativeName || '';
    const mapPromotionFromLayer = (layer = {}) => ({
      promotionName: layer.data_layer_name || layer.promotionName || layer.name || '',
      promotionId: layer.data_layer_id || layer.promotionId || layer.id || '',
      promotionCreativeName:
        layer.data_layer_creative ||
        layer.data_layer_creative_name ||
        layer.promotionCreativeName ||
        layer.promotionCreative_name ||
        layer.promotionCreative ||
        layer.creativeName ||
        '',
      promotionPosition: layer.data_layer_position || layer.promotionPosition || layer.position || '',
      promotionIndex: layer.data_layer_index || layer.promotionIndex || layer.index || '',
      promotionType: layer.data_layer_type || layer.promotionType || layer.type || '',
      promotionButton: layer.data_layer_button || '',
    });
    const getTrackingElement = (node) =>
      node?.closest?.(
        '[data-layer], [data-promotion-id], [data-promotion-name], [data-promotion-position], [data-promotion-creative_name], [data-promotion-creative], [data-promotion-creative-name]'
      );

    let data = {};
    let banner = {};
    if (element?.dataset?.layer) {
      data = JSON.parse(element.dataset.layer);
      banner = mapPromotionFromLayer(data);
      banner.promotionButton = banner.promotionButton || element.dataset.promotionButton;
    } else if (element?.dataset?.promotionPosition === 'deals') {
      banner = {
        promotionName: element.dataset.promotionName,
        promotionId: element.dataset.promotionId,
        promotionCreativeName: getCreativeName(element.dataset),
        promotionPosition: element.dataset.promotionPosition,
        promotionIndex: element.dataset.promotionIndex,
        promotionType: element.dataset.promotionType,
        promotionButton: element.dataset.promotionButton,
      };
    } else {
      const trackingElement = getTrackingElement(element?.parentElement) || getTrackingElement(element);
      if (trackingElement?.dataset) {
        data = Object.assign({}, trackingElement.dataset.layer ? JSON.parse(trackingElement.dataset.layer) : trackingElement.dataset);
      }

      banner = data;
      banner.promotionButton = element.dataset.promotionButton;
      banner.promotionCreativeName = getCreativeName(data);
      banner.promotionCreative = banner.promotionCreativeName;
      delete banner.promotionCreative_name;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'select_promotion', promotions: banner, _clear: true });
    window.location.href = url;
  };

  window.pushImpressionToDataLayer = async (element) => {
    if (!element?.parentNode?.dataset) return;
    const data = Object.assign({}, element.parentNode.dataset);
    const banner = data;
    banner.promotionCreativeName = data.promotionCreative_name || data.promotionCreative || data.promotionCreativeName || data.creativeName || '';
    banner.promotionCreative = banner.promotionCreativeName;
    delete banner.promotionCreative_name;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'select_impressions', promotions: banner, _clear: true });
  };

  initAlgoliaHooks();

  ready(() => {
    initMegaMenus();
    initMobileHeaderDrawer();
    initHeaderNavigation();
    initFooterBehavior();
    initPreventClicks();
    initIECartSubmitFallback();
    initFeaturedProductIEFallback();
    hideDigitalGiftCardDetails();
  });

  document.addEventListener('cart-update', hideDigitalGiftCardDetails);
})();
